/**
 * <dorahi-featured-coupons> — copy-to-clipboard behaviour for
 * sections/dorahi-featured-coupons.liquid.
 *
 * Vanilla port of handleCopy in
 * dorahi-main/components/homepage/FeaturedCouponsSection.tsx:
 *   - navigator.clipboard first, hidden-textarea execCommand fallback
 *   - swaps the copy icon for a green check for 2 seconds
 *
 * Carousel drag / snap / progress / nav buttons live in assets/dorahi-carousel.js.
 */
(function () {
  if (customElements.get('dorahi-featured-coupons')) return;

  const COPIED_TIMEOUT = 2000;

  class DorahiFeaturedCoupons extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-copy-code]');
        if (button) this.copy(button);
      });
    }

    async copy(button) {
      const code = button.dataset.copyCode;

      try {
        // Try modern clipboard API first
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(code);
        } else {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = code;
          textArea.style.position = 'fixed';
          textArea.style.left = '-999999px';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }
        this.showCopied(button);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }

    showCopied(button) {
      const copyIcon = button.querySelector('[data-copy-icon]');
      const checkIcon = button.querySelector('[data-check-icon]');
      if (!copyIcon || !checkIcon) return;

      copyIcon.classList.add('hidden');
      checkIcon.classList.remove('hidden');

      clearTimeout(button.copiedTimer);
      button.copiedTimer = setTimeout(() => {
        copyIcon.classList.remove('hidden');
        checkIcon.classList.add('hidden');
      }, COPIED_TIMEOUT);
    }
  }

  customElements.define('dorahi-featured-coupons', DorahiFeaturedCoupons);
})();
